import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.slide');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

@Component({
    selector: 'wiz-page-slide',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.slide/view.scss */
:host {
  display: block;
  height: 100%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fadeIn {
  animation: fadeIn 0.5s ease-out both;
}

/* Range slider styling */
input[type=range] {
  -webkit-appearance: none;
  appearance: none;
  height: 8px;
  border-radius: 4px;
  background: #3f3f46;
  outline: none;
}
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #a78bfa;
  cursor: pointer;
  border: 2px solid #7c3aed;
  transition: transform 0.15s;
}
input[type=range]::-webkit-slider-thumb:hover {
  transform: scale(1.2);
}
input[type=range]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #a78bfa;
  cursor: pointer;
  border: 2px solid #7c3aed;
}`],
})
export class PageSlideComponent implements OnInit, OnDestroy {
    public slideNum: number = 1;
    public totalSlides: number = 1;

    // Interactive state
    public fairnessTab: string = 'fpr';
    public threshold: number = 5;
    public modeToggle: string = 'blackstone';
    public showSource: boolean = false;

    // Threshold simulation data (approximate values based on COMPAS public stats)
    public thresholdData: any = {};

    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadSlideInfo();
        this.parseSlide();
        this.updateThresholdData();
        this.updateParentSlide();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                this.parseSlide();
                this.updateParentSlide();
                await this.service.render();
            }
        });
    }

    private async loadSlideInfo() {
        let { code, data } = await wiz.call('info');
        if (code === 200) {
            this.totalSlides = data.totalSlides || 19;
        }
        if (this.service.event) {
            this.service.event.emit('slidesLoaded', this.totalSlides);
        }
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private parseSlide() {
        const num = parseInt(WizRoute.segment.num || '1');
        this.slideNum = (num >= 1 && num <= this.totalSlides) ? num : 1;
    }

    private updateParentSlide() {
        // Update layout's current slide number via service event
        if (this.service.event) {
            this.service.event.emit('slideChange', this.slideNum);
        }
    }

    // === Fairness Tab ===
    public setFairnessTab(tab: string) {
        this.fairnessTab = tab;
        this.service.render();
    }

    // === Threshold Slider ===
    public onThresholdChange(event: any) {
        this.threshold = parseInt(event.target.value);
        this.updateThresholdData();
        this.service.render();
    }

    public updateThresholdData() {
        // Simulated data: as threshold increases, FPR decreases but FNR increases
        const t = this.threshold;
        this.thresholdData = {
            black: {
                fpr: Math.max(5, 45 - t * 4.5).toFixed(1),
                fnr: Math.min(95, 10 + t * 8.5).toFixed(1),
                precision: (40 + t * 3).toFixed(1)
            },
            white: {
                fpr: Math.max(3, 23 - t * 2.3).toFixed(1),
                fnr: Math.min(95, 15 + t * 8).toFixed(1),
                precision: (40 + t * 3.2).toFixed(1)
            }
        };
    }

    // === Blackstone vs Cheney Mode ===
    public setMode(mode: string) {
        this.modeToggle = mode;
        this.service.render();
    }

    public getModeData() {
        if (this.modeToggle === 'blackstone') {
            return {
                title: 'Blackstone 원칙',
                subtitle: '"열 명의 죄인을 놓치더라도 한 명의 무고한 사람을 벌하지 않는다"',
                threshold: '높은 임계값 (8/10)',
                tp: 320, fp: 50, tn: 680, fn: 450,
                description: 'False Positive를 최소화 → 무고한 사람의 보호를 우선',
                color: 'teal'
            };
        }
        return {
            title: 'Cheney 원칙',
            subtitle: '"1%의 가능성이라도 있으면 확실한 것으로 대응한다"',
            threshold: '낮은 임계값 (2/10)',
            tp: 700, fp: 480, tn: 250, fn: 70,
            description: 'False Negative를 최소화 → 재범 방지를 우선',
            color: 'amber'
        };
    }

    // === Source toggle ===
    public toggleSource() {
        this.showSource = !this.showSource;
        this.service.render();
    }
}

export default PageSlideComponent;